module.exports = __webpack_public_path__ + "static/media/Scan.b006268b.mp3";